import { Link } from "react-router-dom";
import { BsTable } from "react-icons/bs";

const BOTablesButton = () => {

    return (

        <div align="center">            
            <Link to="/botables">
                <button className="menu-btn" type="button"><BsTable />&nbsp;&nbsp;BO Tables</button>
            </Link>       
        </div>

    )
}

export default BOTablesButton;